var ProfileButton = require("app/Auth/ProfileButton"),
    kind          = require("enyo/kind");

require("app/theme/IconButton--header.less");

module.exports = kind(/** @lends  app.AppHeader.ProfileButton.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.ProfileButton",

    /**
     * @private
     */
    kind: ProfileButton,

    /**
     * @private
     */
    classes: "app-app-header-profile-button",

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: "header"

});
